import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/category/:id',
  title: 'Editar Categoria',
  endpoint: '/public/store_product_category',
}
